export const ROOT = '/warehouse/:warehouse_id/dashboard'
export const LOGIN = '/login'
export const HANDHELD_LINK = '/handheld/link'
// Short alias for the same page. The code is read off a handheld screen and
// typed by hand on another device, so the path length is UX. Both paths stay
// registered: /handheld/link is already baked into QRs in the wild and into
// shipped app builds.
export const HANDHELD_LINK_SHORT = '/hh'
export const SSO_CALLBACK = '/sso-callback'
export const ORDERS = '/warehouse/:warehouse_id/orders'
export const ORDERS_SHIPPED = '/warehouse/:warehouse_id/orders_shipped'
export const REVERSE_LOGISTICS = '/warehouse/:warehouse_id/reverse_logistics'
export const ORDERS_PROCESSING = '/warehouse/:warehouse_id/orders_processing'
export const PROCESSING_ORDER_DETAIL = '/warehouse/:warehouse_id/orders_processing/detail/:id'
export const PICK_N_SHIP = '/warehouse/:warehouse_id/pick-n-ship-orders'
export const SHOW_PICK_N_SHIP_ORDER = '/warehouse/:warehouse_id/pick-n-ship-orders/show/:id'
export const PICKING_PRODUCTIVITIES = '/warehouse/:warehouse_id/picking-productivities'
export const PICKING_TASKS_TO_BREAK = '/warehouse/:warehouse_id/picking-tasks/to-break'
export const GENERATE_LABEL = '/warehouse/:warehouse_id/orders/generate_label/:id'
export const PROCESSING_GENERATE_LABEL = '/orders_processing/generate_label/:id'
export const GENERATE_ORDER_LABEL = '/warehouse/:warehouse_id/generate_label/:id'
export const GENERATE_LABELS = '/warehouse/:warehouse_id/generate_labels'
export const BOX_PACKING_PREVIEW = '/sandbox/box-packing'
export const MULTI_BOX_PACKING_PREVIEW = '/sandbox/multi-box-packing'
export const GENERATE_SHARED_LABEL = '/warehouse/:warehouse_id/generate_shered_label'
export const SHOW_ORDERS = '/warehouse/:warehouse_id/orders/show/:id'
export const INVENTORY = '/warehouse/:warehouse_id/inventory'
export const REPLENISHMENTS = '/warehouse/:warehouse_id/replenishments/'
export const SHOW_REPLENISHMENT = '/warehouse/:warehouse_id/replenishments/detail/:id'
export const SHOW_REPLENISHMENT_BOXES = '/warehouse/:warehouse_id/replenishments/boxes-detail/:id'
export const INBOUND_APPOINTMENTS = '/warehouse/:warehouse_id/inbound-appointments'
export const C2C_RECEIVING = '/warehouse/:warehouse_id/cubbitos'
export const PENDING_PRINTS = '/warehouse/:warehouse_id/pending-prints'
export const WAREHOUSES = '/'
export const SELECT_WAREHOUSE = '/select-warehouse'

export const BILLING = '/warehouse/:warehouse_id/billing'
export const BILLING_STORE_CONFIGS = '/warehouse/:warehouse_id/billing/configs/:store_id'
export const BILLING_STORE_CONFIG_CREATE = '/warehouse/:warehouse_id/billing/configs/:store_id/create'
export const BILLING_STORE_CONFIG_DUPLICATE = '/warehouse/:warehouse_id/billing/configs/:store_id/duplicate/:billing_configuration_id'
export const BILLING_STORE_CREATE_CUSTOM_SERVICE = '/warehouse/:warehouse_id/billing/configs/:store_id/create_custom_service/:billing_configuration_id'

export const CLAIMS = '/warehouse/:warehouse_id/claims'
export const SHOW_CLAIM = '/warehouse/:warehouse_id/claims/detail/:id'

export const CONFIGURATIONS = '/warehouse/:warehouse_id/configurations'
export const CONFIGURATIONS_COBERTURAS = '/warehouse/:warehouse_id/configurations/coverages'
export const CONFIGURATIONS_COBERTURAS_MANAGE = '/warehouse/:warehouse_id/configurations/coverages/manage'
export const CONFIGURATIONS_COBERTURAS_EDIT_BY_RANGE = '/warehouse/:warehouse_id/configurations/coverages/:shipping_method_id/edit-by-range'
export const CONFIGURATIONS_COBERTURAS_EDIT_ALL = '/warehouse/:warehouse_id/configurations/coverages/:shipping_method_id/edit-all'
export const CONFIGURATIONS_COBERTURAS_BULK_MANAGE = '/warehouse/:warehouse_id/configurations/coverages/:shipping_method_id/bulk-manage'
export const CONFIGURATIONS_OPERATORS = '/warehouse/:warehouse_id/configurations/operators'
export const CONFIGURATIONS_OPERATORS_DETAIL = '/warehouse/:warehouse_id/configurations/operators/detail'
export const CONFIGURATIONS_CAIXAS = '/warehouse/:warehouse_id/configurations/boxes'
export const CONFIGURATIONS_STORE_BOXES = '/warehouse/:warehouse_id/configurations/store-boxes'
export const CONFIGURATIONS_CONTAINER_TEMPLATES = '/warehouse/:warehouse_id/configurations/container-templates'
export const CONFIGURATIONS_CONTAINER_TEMPLATE_EDITOR = '/warehouse/:warehouse_id/configurations/container-templates/:template_id'
export const CONFIGURATIONS_CONTAINER_TEMPLATE_CREATE = '/warehouse/:warehouse_id/configurations/container-templates/new'
export const CONFIGURATIONS_BARCODE_POOL = '/warehouse/:warehouse_id/configurations/barcode-pool'
export const CONFIGURATIONS_SALES_CHANNELS = '/warehouse/:warehouse_id/configurations/sales-channels'
export const CONFIGURATIONS_CAMPAIGNS = '/warehouse/:warehouse_id/configurations/campaigns'
export const CONFIGURATIONS_RECEIVING_CAPACITY_OVERRIDES = '/warehouse/:warehouse_id/configurations/receiving-capacity-overrides'
export const CONFIGURATIONS_RECEIVING = '/warehouse/:warehouse_id/configurations/receiving'
export const CONFIGURATIONS_RECEIVING_SETTINGS = `${CONFIGURATIONS_RECEIVING}/settings`
export const CONFIGURATIONS_RECEIVING_OVERRIDES = `${CONFIGURATIONS_RECEIVING}/overrides`
export const CONFIGURATIONS_RECEIVING_HISTORY = `${CONFIGURATIONS_RECEIVING}/history`
export const CONFIGURATIONS_PACKING = '/warehouse/:warehouse_id/configurations/packing'
export const CONFIGURATIONS_DISPATCH_RECIPIENTS = '/warehouse/:warehouse_id/configurations/dispatch-recipients'
export const OPERATORS = '/warehouse/:warehouse_id/operators'
export const SHOW_OPERATORS = '/warehouse/:warehouse_id/operators/detail'

export const CREATE_RETURN = '/warehouse/:warehouse_id/orders_shipped/:orderId/create-return'
export const SHOW_CREATING_RETURN_ORDER = '/warehouse/:warehouse_id/orders_shipped/:orderId/create-return/show-order/:id'
export const CREATE_RETURN_REVERSE_LOGISTICS = '/warehouse/:warehouse_id/reverse_logistics/:orderId/create-return'
export const SHIPPED_ORDER_DETAIL = '/warehouse/:warehouse_id/orders_shipped/detail/:id'
export const SHIPPED_ORDER_DETAIL_REVERSE = '/warehouse/:warehouse_id/reverse_logistics/detail/:id'

export const SEARCH_RETURN = '/warehouse/:warehouse_id/returns/:scann_string/search'
export const RECEIVE_RETURNED_ORDER = '/warehouse/:warehouse_id/returns/order/:order_id/receive'

export const ORDER_DETAIL = '/warehouse/:warehouse_id/:origin/detail/:id'

export const RETURNS = '/warehouse/:warehouse_id/returns'
export const SHOW_RETURN = '/warehouse/:warehouse_id/returns/detail/:id'
export const SHOW_ORDER_RETURNS = '/warehouse/:warehouse_id/returns/show-order/:id'
export const RECEIVE_RETURN = '/warehouse/:warehouse_id/returns/:id/receive'
export const SHOW_RECEIVING_ORDER = '/warehouse/:warehouse_id/returns/:returnId/receive/show-order/:id'

export const LOCATIONS = '/warehouse/:warehouse_id/locations'
export const VIEW_WAREHOUSE_LOCATIONS = '/warehouse/:warehouse_id/locations/view'

export const INVENTORY_HISTORY = '/warehouse/:warehouse_id/inventory_history'

export const WORK_ORDERS = '/warehouse/:warehouse_id/work-orders'
export const SHOW_WORK_ORDER = '/warehouse/:warehouse_id/work-orders/detail/:id'

export const ACCESS_DENIED = '/access_denied'

export const STORE_BILLING_STATUS_ACTIVE = 'ACTIVE'
export const STORE_BILLING_STATUS_DISABLED = 'DISABLED'
export const STORE_BILLING_STATUS_UNREQUIRED = 'UNREQUIRED'
export const STORE_BILLING_STATUS_PENDING = 'PENDING'

export const REASSING_CARRIER = '/warehouse/:warehouse_id/reassing-carrier'

export const NATURA_REPLENISHMENTS = '/warehouse/:warehouse_id/natura-replenishments'

export const NATURA_OPS_CREATE_ORDER = '/warehouse/:warehouse_id/natura-operations/create-order'
export const NATURA_OPS_PICKING = '/warehouse/:warehouse_id/natura-operations/picking'
export const NATURA_OPS_NOTA_FISCAL = '/warehouse/:warehouse_id/natura-operations/nota-fiscal'
export const NATURA_OPS_DEPOSIT_TRANSFER = '/warehouse/:warehouse_id/natura-operations/deposit-transfer'
export const NATURA_OPS_NOTFIS_UPLOAD = '/warehouse/:warehouse_id/natura-operations/notfis-upload'
export const NATURA_OPS_CONFIRMATION_RESEND = '/warehouse/:warehouse_id/natura-operations/confirmation-resend'

export const ESTAFETA_ADDRESS_CORRECTOR = '/warehouse/:warehouse_id/estafeta-address-corrector/:order_id'
export const DELETE_LOST_STOCK = '/warehouse/:warehouse_id/delete-lost-stock'
export const DELETED_LOST_HISTORY = '/warehouse/:warehouse_id/deleted-lost-history'

export const SHIPPING_PACKAGES = '/warehouse/:warehouse_id/shipping-packages'

export const LASTMILE_SHIPPING_METHODS = '/warehouse/:warehouse_id/lastmile-shipping-methods'
export const LASTMILE_SHIPPING_METHOD_COVERAGES = '/warehouse/:warehouse_id/lastmile-shipping-methods/:shipping_method_id/coverages'
export const LASTMILE_SHIPPING_METHOD_COVERAGES_BY_RANGE = '/warehouse/:warehouse_id/lastmile-shipping-methods/:shipping_method_id/coverages/edit-by-range'
export const LASTMILE_SHIPPING_METHOD_COVERAGES_ALL = '/warehouse/:warehouse_id/lastmile-shipping-methods/:shipping_method_id/coverages/edit-all'
export const LASTMILE_SHIPPING_METHOD_COVERAGES_BULK_MANAGE = '/warehouse/:warehouse_id/lastmile-shipping-methods/:shipping_method_id/coverages/bulk-manage'
export const DISPATCH_SCHEDULES = '/warehouse/:warehouse_id/dispatch-schedules'
// The romaneios (carrier handover documents) of the warehouse; ?number= opens on one.
export const ROMANEIOS = '/warehouse/:warehouse_id/romaneios'
export const PROOF_VIDEO_COVERAGE = '/warehouse/:warehouse_id/proof-video-coverage'
export const PROOF_VIDEO_COVERAGE_PERMISSION = 'proof_video_coverage_read'
export const AUTOMATED_COVERAGE_DEACTIVATIONS = '/warehouse/:warehouse_id/lastmile/coverage-deactivations'
export const CYCLE_COUNTS = '/warehouse/:warehouse_id/cycle-counts'
export const FULFILLMENT_ERRORS = '/warehouse/:warehouse_id/fulfillment-errors'
export const FULFILLMENT_ERROR_ORDER_DETAIL = '/warehouse/:warehouse_id/fulfillment-errors/detail/:id'
export const FOUND_STOCK = '/warehouse/:warehouse_id/found-stock'

export const WORKFORCE = '/warehouse/:warehouse_id/workforce'
export const WORKFORCE_RATES = '/warehouse/:warehouse_id/workforce/rates'
export const WORKFORCE_COSTS = '/warehouse/:warehouse_id/workforce/costs'
export const WORKFORCE_SHIFTS = '/warehouse/:warehouse_id/workforce/shifts'
export const WORKFORCE_OPERATORS = '/warehouse/:warehouse_id/workforce/operators'
export const WORKFORCE_ATTENDANCE = '/warehouse/:warehouse_id/workforce/attendance'
export const WORKFORCE_SCHEDULE = '/warehouse/:warehouse_id/workforce/schedule'

export const UBER_BATCHES = '/warehouse/:warehouse_id/uber-batches'
export const UBER_BATCH_DETAIL = '/warehouse/:warehouse_id/uber-batches/:id'
